import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../features/user/selectors'
import { sort } from '../../../utilities/options.util'
import { ProcedureService } from '../services/procedure.service'
import { setNemsisCodeOptions } from '../store/procedure.actions'

export function* getNemsisCodeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const procedureService = new ProcedureService(serviceId)
  try {
    const nemsisCodeOptionsResponse: IOptionsResponse = yield call([
      procedureService,
      procedureService.getNemsisCodeOptions,
    ])
    const { entity } = nemsisCodeOptionsResponse
    sort(entity)
    yield put(setNemsisCodeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getNemsisCodeOptions() error: ${e}`))
  }
}

export function* getNemsisCodeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getNemsisCodeOptions)
}
